import { useTranslation } from '../../../../../shared/i18n';
import React from 'react';
import { Tag, Tooltip } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

/** 付款后续费是异步执行的：显示「续费中 / 续费失败」 */
const RenewalTag = ({ renewal }) => {
    const { t } = useTranslation();
    if (!renewal) return null;
    if (renewal.state === 'renewing') {
        return (
            <Tooltip title={renewal.last_error ? t('Last attempt: {{last_error}}', { last_error: renewal.last_error }) : t('Paid, renewing with registrar')}>
                <Tag icon={<SyncOutlined spin />} color="processing">{t('Renewing')}</Tag>
            </Tooltip>
        );
    }
    if (renewal.state === 'renew_failed') {
        return (
            <Tooltip title={t('{{value}}, the payment has been refunded to your balance', { value: renewal.last_error || t('Renewal failed') })}>
                <Tag color="error">{t('Renewal failed')}</Tag>
            </Tooltip>
        );
    }
    return null;
};

export default RenewalTag;
